<template>
  <div class="toast-container" aria-live="polite">
    <div
      v-for="toast in toasts"
      :key="toast.id"
      class="toast"
      :class="`toast-${toast.type}`"
      role="alert"
    >
      <span>{{ toast.message }}</span>
      <button type="button" class="toast-close" aria-label="Dismiss" @click="remove(toast.id)">×</button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useToast } from '@/composables/useToast';

export default defineComponent({
  name: 'AppToast',
  setup() {
    const { toasts, remove } = useToast();
    return { toasts, remove };
  },
});
</script>

<style scoped>
.toast-container {
  position: fixed;
  top: calc(var(--header-height, 80px) + 12px);
  right: 16px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: min(400px, calc(100vw - 32px));
}

.toast {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  font-size: 0.95em;
  animation: slide-in 0.2s ease-out;
}

.toast-success {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.toast-error {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.toast-info {
  background-color: #fff;
  color: var(--text-dark, #333);
  border: 1px solid #ddd;
}

.toast-close {
  background: none;
  border: none;
  font-size: 1.25em;
  line-height: 1;
  cursor: pointer;
  padding: 0 4px;
  opacity: 0.7;
}

.toast-close:hover {
  opacity: 1;
}

@keyframes slide-in {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
</style>
